// src/components/Loader.jsx
import React from "react";

const Loader = () => (
  <div className="d-flex w-100  align-items-center justify-content-center">
    <img
      className="w-200-px ml-2 "
      src="/assets/images/preloader/Loader-2.svg"
    ></img>
  </div>
);

export default Loader;
